module.exports = __webpack_public_path__ + "static/media/spinner-primary.0e49c2a7.svg";